/* eslint-disable @typescript-eslint/no-explicit-any */
export interface HttpResponse<T> {
  body: T;
  status: number;
  url: string;
}

export const UNDER_MAINTENANCE_CODE = 503;
export const UNAUTHORIZED_CODE = 401;
export const GONE_CODE = 410;

export abstract class IHttpClient {
  public abstract get<T = any>(urlWithQueryParams: string): Promise<HttpResponse<T>>;

  public abstract post<T = any>(url: string, body: any): Promise<HttpResponse<T>>;

  public abstract postFormData<T = any>(url: string, formData: FormData): Promise<HttpResponse<T>>;

  public abstract put<T = any>(url: string, body: any): Promise<HttpResponse<T>>;

  public abstract patch<T = any>(url: string, body: any): Promise<HttpResponse<T>>;

  public abstract delete<T = any>(url: string): Promise<HttpResponse<T>>;

  public abstract getBlob(url: string): Promise<HttpResponse<Blob>>;

  public abstract buildUrl(url: string): string;
  public abstract getToken(): string;
}
